<div class="page-title">
  </div>
  <div *ngIf="loggedInUser" class="welcome-msg">
    <h4>Hello <span><strong>{{userProfile.full_name}}</strong></span>!<br></h4>
  </div>
  <div class="box-account box-info">
    <div class="box-head">
      <h4>Account Information</h4>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="box">
          <div *ngIf="loggedInUser" class="box-title">
            <div class="info-item">
              <span class="info-label">Email Id</span>
              <span class="info-value">{{business_email}}</span>
            </div>
            <div class="info-item" *ngIf="isVendor">
              <span class="info-label">User Name</span>
              <span class="info-value">{{userProfile.username}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Name</span>
              <span class="info-value">{{userProfile.full_name}}</span>
            </div>
            <!-- <div class="info-item">
              <span class="info-label">User Type</span>
              <span class="info-value">{{userProfile.user_type}}</span>
            </div> -->
          </div>
        </div>
        </div>
        <div class="col-sm-6">
            <div class="box">
                <div class="box-head">
                    <span><h4> Change Password </h4></span>
                </div>

                <form [formGroup]="changePasswordForm" (ngSubmit)="submitNewPassword()">
                    <div class="form-group">
                        <label for="newPassword">New Password</label>
                        <!-- <input type="password" id="newPassword" formControlName="newPassword" class="form-control" required> -->
                        <p-password formControlName="newPassword" [toggleMask]="true"  />
                        <small *ngIf="changePasswordForm.get('newPassword')?.invalid && (changePasswordForm.get('newPassword')?.dirty || changePasswordForm.get('newPassword')?.touched)">
                            <small class="text-danger" *ngIf="changePasswordForm.get('newPassword')?.errors?.['required']">Password is required.</small>
                            <small class="text-danger" *ngIf="changePasswordForm.get('newPassword')?.errors?.['minlength']">Password must be at least 6 characters long.</small>
                        </small>
                    </div>
                    <div class="form-group">
                        <label for="confirmPassword">Confirm Password</label>
                        <!-- <input type="password" id="confirmPassword" formControlName="confirmPassword" class="form-control" required> -->
                        <p-password formControlName="confirmPassword" [toggleMask]="true" />
                        <small *ngIf="changePasswordForm.get('confirmPassword')?.invalid && (changePasswordForm.get('confirmPassword')?.dirty || changePasswordForm.get('confirmPassword')?.touched)">
                            <small class="text-danger" *ngIf="changePasswordForm.get('confirmPassword')?.errors?.['required']">Confirm Password is required.</small>
                            <small class="text-danger" *ngIf="changePasswordForm.get('confirmPassword')?.errors?.['minlength']">Confirm Password must be at least 6 characters long.</small>
                        </small>
                        <div *ngIf="changePasswordForm.errors?.['mismatch'] && (changePasswordForm.get('confirmPassword')?.dirty || changePasswordForm.get('confirmPassword')?.touched)">
                            <small class="text-danger">Passwords do not match.</small>
                        </div>
                    </div>
                        <button type="submit" class="btn btn-primary mt-3">Submit</button>
                </form>
            </div>
        </div>
    </div>
  </div>
  <p-toast></p-toast>
